// extracted by mini-css-extract-plugin
export default {"wrapper":"Settings_wrapper__1QOnM"};